<template>
  <span class="fg-gl-news">
    <span>Follow Us On :</span>
    <a
      :href="extLink"
      class="fg-google-news"
      @click="captureGoogleNewsClick($event)"
    >
      <img src="/static-assets/images/cssimages/google-news-feature-img.jpg?w=50" />
    </a>
  </span>
</template>

<script>
import {
  addPagePropertiesToObject,
  sendTrackingData,
} from "../../assets/js/common";
import { CFG_TRACKING } from "../../assets/js/config";
export default {
  data() {
    return {
      extLink: "https://news.google.com/publications/CAAqBwgKMMLyrAswz_3EAw",
    };
  },
  methods: {
    captureGoogleNewsClick(e) {
      e.preventDefault();
      let toTrack = CFG_TRACKING["2"];
      toTrack.category = "fg-google-news";
      toTrack.label = "fg-google-news";
      toTrack.value = this.extLink;
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
      window.open(this.extLink, "_blank");
    },
  },
};
</script>